import { render, staticRenderFns } from "./Category.html?vue&type=template&id=73a41148&scoped=true&"
import script from "./Category.ts?vue&type=script&lang=ts&"
export * from "./Category.ts?vue&type=script&lang=ts&"
import style0 from "./Category.css?vue&type=style&index=0&id=73a41148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a41148",
  null
  
)

export default component.exports